import { Chip, Stack, Typography, makeStyles } from '@gogame/components';

const useStyles = makeStyles(() => ({
  root: {
    margin: '16px 4px 0 0',
  },
  chip: {
    margin: '4px 8px 4px 0 !important',
  },
}));
const FavouriteMetrics = ({
  favouriteMetrics,
  onChipClick,
  queryTokens,
  name,
}) => {
  const classes = useStyles();
  return (
    <Stack className={classes.root} spacing={1}>
      <Typography variant={'caption'} color={'textSecondary'}>
        {name}
      </Typography>
      <Stack direction={'row'} spacing={1}>
        {favouriteMetrics.map(({ name, id }) => (
          <Chip
            key={id}
            label={name}
            checked={queryTokens.includes(name)}
            variant={'outlined'}
            onClick={() => onChipClick(name)}
          />
        ))}
      </Stack>
    </Stack>
  );
};

export default FavouriteMetrics;
